import type { Batch, BatchStatus } from '../types';

export const getStatusBadge = (batch: Batch, variant: 'admin' | 'ad' = 'admin'): { label: string; cls: string } => {
    const isAd = variant === 'ad';

    if (batch.approvalType === 'single_point' && batch.status === 'ad_selected') {
        return { label: 'Approvals Submitted', cls: 'ready-to-commit' };
    }

    if (batch.status === 'ad_selected' && batch.adZeroSelection) {
        return { label: 'Rejected by Artistic Staff', cls: 'rejected' };
    }

    if (batch.status === 'ad_selected' && batch.allPhotosTagged) {
        return { label: isAd ? 'Awaiting Commit' : 'Ready to Commit', cls: 'ready-to-commit' };
    }

    if (batch.status === 'uploaded' && !isAd) {
        if (!batch.assignedAdId) return { label: 'Awaiting Artistic Staff Assignment', cls: 'unassigned' };
        if (!batch.adNotified)   return { label: 'Ready to Notify Artistic Staff', cls: 'not-notified' };
    }

    return (
        {
            empty:       { label: 'Empty',                                                        cls: 'empty' },
            uploaded:    { label: isAd ? 'Ready to Select' : 'Awaiting Artistic Staff Selection', cls: 'awaiting' },
            ad_selected: { label: isAd ? 'Awaiting Tagging' : 'Ready to Tag',                    cls: 'ready' },
            pending:     { label: 'In Review',                                                    cls: 'in-review' },
            processed:   { label: 'Processed',                                                    cls: 'processed' },
            review_open: { label: 'Review Open',                                                  cls: 'review-open' },
        } satisfies Record<BatchStatus, { label: string; cls: string }>
    )[batch.status] ?? { label: batch.status, cls: '' };
};